import React, { useEffect, useState } from "react";
import { usePermitted } from "../../common/components/permissions/permissions";
import TabbedContainer from "../../App/components/common/TabbedContainer";
import MarketAdmin from "./markets/marketAdmin";
import CurrencyAdmin from "./currencies/currencyAdmin";
import UomAdmin from "./uoms/uomAdmin";
import VenueAdmin from "./venues/venueAdmin";
import PriceBasisAdmin from "./priceBases/priceBasisAdmin";
import TermAdmin from "./terms/termAdmin";
import { useTranslation } from "react-i18next";

const AuthAdmin = () => {
  const [activeTab, setActiveTab] = useState(null);
  const queryMarkets = usePermitted(["api-query-markets"]);
  const manageMarkets = usePermitted(["api-manage-markets"]);
  const queryCurrencies = usePermitted(["api-query-currencies"]);
  const manageCurrencies = usePermitted(["api-manage-currencies"]);
  const queryUoms = usePermitted(["api-query-uoms"]);
  const manageUoms = usePermitted(["api-manage-uoms"]);
  const queryVenues = usePermitted(["api-query-venues"]);
  const manageVenues = usePermitted(["api-manage-venues"]);
  const queryPriceBases = usePermitted(["api-query-price-bases"]);
  const managePriceBases = usePermitted(["api-manage-price-bases"]);
  const queryTerms = usePermitted(["api-query-terms"]);
  const manageTerms = usePermitted(["api-manage-terms"]);
  const { t } = useTranslation(["markets"]);
  const tabs = [
    queryMarkets && {
      id: "1",
      label: t("Markets"),
      content: <MarketAdmin allowEdit={manageMarkets} />,
    },
    queryCurrencies && {
      id: "2",
      label: t("Currencies"),
      content: <CurrencyAdmin allowEdit={manageCurrencies} />,
    },
    queryPriceBases && {
      id: "3",
      label: t("PriceBasis"),
      content: <PriceBasisAdmin allowEdit={managePriceBases} />,
    },
    queryTerms && {
      id: "4",
      label: t("Terms"),
      content: <TermAdmin allowEdit={manageTerms} />,
    },
    queryUoms && {
      id: "5",
      label: t("Uoms"),
      content: <UomAdmin allowEdit={manageUoms} />,
    },
    queryVenues && {
      id: "6",
      label: t("Venues"),
      content: <VenueAdmin allowEdit={manageVenues} />,
    },
  ].filter(Boolean);
  const firstTabId = tabs[0]?.id;
  const hasActiveTab = tabs.some((tab) => tab.id === activeTab);

  useEffect(() => {
    if (firstTabId && !hasActiveTab) {
      setActiveTab(firstTabId);
    }
  }, [firstTabId, hasActiveTab]);

  return (
    <TabbedContainer
      activeTab={activeTab ?? firstTabId ?? ""}
      onTabChange={setActiveTab}
      tabs={tabs}
    />
  );
};

export default AuthAdmin;

// class AuthAdmin extends Component {

//     render() {
//         return (

//         );
//     }
// }

// export default AuthAdmin;
